import "../../App.css";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";

// Embebe el dashboard de QuickSight via embed-url firmada que genera el backend.
// La URL caduca en minutos: pedimos una fresca en cada montaje del componente.
// Si el usuario logueado no esta registrado en QuickSight, mostramos un mensaje
// claro en vez del iframe roto.
function Quicksight() {
  const [embedUrl, setEmbedUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmbed = async () => {
      try {
        const usuario = CurrentUser.user();
        if (!usuario || !usuario.key) {
          setError("Necesitas estar logueado para ver los reportes.");
          setLoading(false);
          return;
        }
        const res = await fetch(
          Parametros.urlApi + "reports/quicksight/embed-url",
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();
        if (!res.ok) {
          setError(data.detail || "No se pudo cargar el dashboard.");
          setLoading(false);
          return;
        }
        setEmbedUrl(data.embed_url);
        setLoading(false);
      } catch (e) {
        console.error("Error pidiendo embed-url:", e);
        setError("Error de red al cargar el dashboard.");
        setLoading(false);
      }
    };
    fetchEmbed();
  }, []);

  return (
    <div className="App">
      <Sidebar tipo="1" />
      <br />
      <UserTab nombre={"KPI"} />
      <div className="container" style={{ paddingBottom: 24 }}>
        {loading && (
          <div style={{ textAlign: "center", padding: 60, color: "#475569" }}>
            Cargando dashboard...
          </div>
        )}

        {error && !loading && (
          <div
            className="alert alert-danger"
            style={{
              padding: 16,
              borderRadius: 12,
              background: "#FEE2E2",
              color: "#991B1B",
              border: "1px solid #FCA5A5",
              textAlign: "left",
            }}
          >
            <strong>No se pudo cargar el dashboard.</strong>
            <div style={{ marginTop: 8, fontSize: 13 }}>{error}</div>
          </div>
        )}

        {embedUrl && !loading && !error && (
          <iframe
            title="QuickSight Dashboard"
            src={embedUrl}
            style={{
              width: "100%",
              height: "calc(100vh - 180px)",
              minHeight: 600,
              border: "1px solid #E2E8F0",
              borderRadius: 12,
              background: "#FFFFFF",
            }}
            allowFullScreen
          />
        )}
      </div>
    </div>
  );
}

export default withRouter(Quicksight);
